import { render, staticRenderFns } from "./DashboardActivePlacementItem.vue?vue&type=template&id=27af3b21&"
import script from "./DashboardActivePlacementItem.vue?vue&type=script&lang=js&"
export * from "./DashboardActivePlacementItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports